<template>
    <div class="group-recipient-case">
        <div class="label-recipient mr-1">
            <span>
                ที่อยู่ผู้รับ
            </span>
            <span class="warning-text">
                {{ basefillupSetting.mutedText }}
            </span>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
                <label class="label-input" for="">
                    <p class="m-0">    
                        <span class="text-danger">*</span><span>Consignee Name </span><span class="muted">(ชื่อ นามสกุล ผู้รับ)</span>
                    </p>
                </label>
                <!-- <input v-model="inputRecipient.name" :class="{ 'is-invalid': errorshow.inputRecipient.name.language || inputRecipientValidation.name.$error }" type="text" class="form-control" placeholder=""> -->

                <autocomplete :search="searchRecipientDetailsInter"
                    :get-result-value="getValueRecipientDetailsInter" @submit="onSubmitRecipient"
                    v-on:input="inputRecipient.name = $event.target.value" :value="inputRecipient.name"
                    :class="[{ 'is-invalid': errorshow.inputRecipient.name.language || inputRecipientValidation.name.$error }]">
                    <template v-slot:result="{ result, props }">
                      <li v-bind="props">
                        <h6>
                          Name:{{ result.name }} Tel:{{ result.tel }} 
                          Address:{{ result.address }}
                          {{ result.address2 ? `Address2: ${result.address2}` : `` }}
                          City:{{ result.district }}
                          State:{{ result.state }} Country:{{ result.province }}
                          Postal Code:{{ result.postcode }}
                        </h6>
                      </li>
                    </template>
                </autocomplete>
                <label
                    v-if="!inputRecipientValidation.name.required"
                    class="invalid-feedback"
                >กรุณากรอก ชื่อ-สกุล</label>
                <label
                    v-if="errorshow.inputRecipient.name.language"
                    class="invalid-feedback"
                >
                    กรุณากรอกข้อมูลเป็น {{ LanguageMessage }}
                </label>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
                    <label class="label-input" for="">
                        <p class="m-0">    
                            <span class="text-danger">*</span><span>Consignee Phone number </span><span class="muted">(เบอร์โทรศัพท์ผู้รับ)</span>
                        </p>
                    </label>
                    <div class="row">
                        <div class="col-1 col-md-4 col-lg-4">
                            <b-form-group id="input-group-1" label-for="input-1">
                                <v-select 
                                    :options="countries"
                                    label="text"
                                    @input="SetseletedCountry($event)"
                                    v-model="inputRecipient.selectedPhoneCountry.showInput"
                                    :class="{ 'is-invalid bd-danger': inputRecipientValidation.selectedPhoneCountry.alpha_2_code.$error }" 
                                >                        
                                <template slot="option" slot-scope="option">
                                    +{{ option.calling_code }} {{ option.text }}
                                </template>
                                </v-select>
                                <label
                                v-if="!inputRecipientValidation.selectedPhoneCountry.alpha_2_code.required"
                                class="invalid-feedback">
                                    กรุณาเลือกประเทศ เบอร์โทรศัพท์
                                </label>
                            </b-form-group>
                        </div>
                        <div class="col-11 col-md-8 col-lg-8">
                            <!-- <input class="form-control" type="text" id="phone" v-model="inputRecipient.tel" :class="{ 'is-invalid': inputRecipientValidation.tel.$error }" @input="formatPhoneNumber"> -->
                            <autocomplete :search="searchRecipientDetailsInter"
                                :get-result-value="getValueRecipientDetailsInter" @submit="onSubmitRecipient"
                                v-on:input="inputRecipient.tel = $event.target.value" :value="inputRecipient.tel"
                                :class="[{ 'is-invalid': inputRecipientValidation.tel.$error }]">
                                <template v-slot:result="{ result, props }">
                                  <li v-bind="props">
                                    <h6>
                                      ชื่อ:{{ result.name }} เบอร์:{{ result.tel }} 
                                      ที่อยู่1:{{ result.address }}
                                      {{ result.address2 ? `ที่อยู่2: ${result.address2}` : `` }}
                                      ตำบล:{{ result.district }}
                                      อำเภอ:{{ result.state }} จังหวัด:{{ result.province }}
                                      รหัสปณ.:{{ result.postcode }}
                                    </h6>
                                  </li>
                                </template>
                            </autocomplete>
                            <label
                                v-if="!inputRecipientValidation.tel.required"
                                class="invalid-feedback"
                            >กรุณากรอกเบอร์โทร</label>
                        </div>
                    </div>
                    
            </div>
            <div class="col-12 col-md-6 col-lg-6">
                    <label class="label-input" for="">
                        <p class="m-0">    
                            <span>Company </span><span class="muted">(ชื่อบริษัท)</span>
                        </p>
                    </label>
                    <input class="form-control" 
                        type="text" maxlength="30"
                        :class="{ 'is-invalid': errorshow.inputRecipient.company.language }" 
                        v-model="inputRecipient.company">
                    <label
                    v-if="errorshow.inputRecipient.company.language"
                    class="invalid-feedback"
                    >
                        กรุณากรอก ชื่อ-บริษัท เป็น{{ LanguageMessage }}
                    </label>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
                <label class="label-input" for="">
                    <p class="m-0">    
                        <span>Taxpayer ID </span><span class="muted">(หมายเลขผู้เสียภาษี)</span>
                    </p>
                </label>
                <input class="form-control" type="text" v-model="inputRecipient.taxId">
            </div>
            <div class="col-12 col-md-12 col-lg-12">
                <label class="label-input" for="">
                    <p class="m-0">    
                        <span class="text-danger">*</span><span>Consignee Address 1 </span><span class="muted">(ที่อยู่ผู้รับ)</span>
                    </p>
                </label>
                <input v-model="inputRecipient.address" :maxlength="maxCharacters" :class="{ 'is-invalid': errorshow.inputRecipient.address.language || inputRecipientValidation.address.$error }" type="text" class="form-control" placeholder="">
                <label
                    v-if="!inputRecipientValidation.address.required"
                    class="invalid-feedback"
                >กรุณากรอกที่อยู่ผู้รับ</label>
                <label
                    v-if="errorshow.inputRecipient.address.language"
                    class="invalid-feedback"
                >
                    กรุณากรอกข้อมูลเป็น {{ LanguageMessage }}
                </label>
            </div>
            <div class="col-12 col-md-12 col-lg-12">
                <label class="label-input" for="">
                    <p class="m-0">    
                        <span>Consignee Address 2 </span><span class="muted">(ที่อยู่ผู้รับ)</span>
                    </p>
                </label>
                <input v-model="inputRecipient.address2" :maxlength="maxCharacters" :class="{ 'is-invalid': errorshow.inputRecipient.address2.language }" type="text" class="form-control" placeholder="">
                <label
                    v-if="errorshow.inputRecipient.address2.language"
                    class="invalid-feedback"
                >
                    กรุณากรอกข้อมูลเป็น {{ LanguageMessage }}
                </label>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
                <label class="label-input" for="">
                    <p class="m-0">    
                        <span class="text-danger">*</span><span>Destination Country </span><span class="muted">(ประเทศปลายทาง)</span>
                    </p>
                </label>
                <b-form-group id="input-group-1" label-for="input-1">
                    <v-select 
                        :options="countries" 
                        label="text"
                        :class="{ 'is-invalid bd-danger': inputRecipientValidation.country.text.$error }" 
                        @input="assigninputRecipient($event)"
                        v-model="inputRecipient.country.text"
                        :disabled="disableSelectedCountry"
                    >
                    <template slot="selected-option" slot-scope="option">
                        <span>
                        {{ option.text }}
                        </span>
                    </template>
                    </v-select>
                    <label
                    v-if="!inputRecipientValidation.country.text.required"
                    class="invalid-feedback">
                        กรุณากรอกประเทศปลายทาง
                    </label>
                </b-form-group>
                
            </div>
            <div class="col-12 col-md-6 col-lg-6">
                <label class="label-input" for="">
                    <p class="m-0">    
                        <span class="text-danger">*</span><span>State </span><span class="muted">(รัฐ)</span>
                    </p>
                </label>
                <input v-model="inputRecipient.state" :class="{ 'is-invalid': errorshow.inputRecipient.state.language || inputRecipientValidation.state.$error }" type="text" class="form-control" placeholder="">
                <label
                    v-if="!inputRecipientValidation.state.required"
                    class="invalid-feedback"
                >กรุณากรอกรัฐ</label>
                <label
                    v-if="errorshow.inputRecipient.state.language"
                    class="invalid-feedback"
                >
                    กรุณากรอกข้อมูลเป็น {{ LanguageMessage }}
                </label>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
                <label class="label-input" for="">
                    <p class="m-0">    
                        <span class="text-danger">*</span><span>City </span><span class="muted">(เมือง)</span>
                    </p>
                </label>
                <div v-if="selectedCourier.key !== 'LAO'">
                    <input v-model="inputRecipient.city" :class="{ 'is-invalid': errorshow.inputRecipient.city.language || inputRecipientValidation.city.$error }" type="text" class="form-control" placeholder="">
                    <label
                        v-if="!inputRecipientValidation.city.required"
                        class="invalid-feedback"
                    >กรุณากรอกเมือง</label>
                    <label
                        v-if="errorshow.inputRecipient.city.language"
                        class="invalid-feedback"
                    >
                        กรุณากรอกข้อมูลเป็น {{ LanguageMessage }}
                    </label>
                </div>
                <div v-else>
                    <div>
                        <v-select 
                        :options="laosProvinces" 
                        label="text"
                        :class="{ 'is-invalid bd-danger': inputRecipientValidation.city.$error }" 
                        @input="assignCityLAO($event)"
                        v-model="inputRecipient.city"
                        >
                        </v-select>
                    </div>
                    <label
                        v-if="!inputRecipientValidation.city.required"
                        class="invalid-feedback"
                        >กรุณาเลือกจังหวัด
                    </label>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
                <label class="label-input" for="">
                    <p class="m-0">    
                        <span class="text-danger">*</span><span>Postal Code </span><span class="muted">(รหัสไปรษณีย์)</span>
                    </p>
                </label>
                <input v-model="inputRecipient.postcode" :class="{ 'is-invalid': inputRecipientValidation.postcode.$error }" type="text" class="form-control" placeholder="">
                <label
                    v-if="!inputRecipientValidation.postcode.required"
                    class="invalid-feedback"
                >กรุณากรอกรหัสไปรษณีย์</label>
            </div>
        </div>
    </div>
</template>

<script>
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { getCountryCallingCode } from 'libphonenumber-js/max';
import { searchRecipientDetailsInter, getValueRecipientDetailsInter } from "@/axios/search.js";


export default {
    props: {
        selectedCourier: {
            type: [Object, String]
        },
        disableSelectedCountry: {
            type: Boolean,
            default: false
        },
        errorshow: [Array, Object],
        countries: [Array, Object],
        inputRecipient: {
            type: [Object,Array]
        },
        inputRecipientValidation: {
            required: true
        },
        basefillupSetting: {
            type: Object
        }
    },
    data() {
        return {
            searchRecipientDetailsInter: searchRecipientDetailsInter,
            getValueRecipientDetailsInter: getValueRecipientDetailsInter,
            filteredCountries: [],
            laosProvinces: [
                { text: 'เวียงจันทน์' },
                { text: 'คำม่วน' },
                { text: 'จำปาสัก' },
                { text: 'เชียงขวาง' },
                { text: 'ไชยบุรี' },
                { text: 'ไชยสมบูรณ์' },
                { text: 'เซกอง' },
                { text: 'บอลิคำไซ' },
                { text: 'บ่อแก้ว' },
                { text: 'พงสาลี' },
                { text: 'สาละวัน' },
                { text: 'สะหวันนะเขต' },
                { text: 'หลวงน้ำทา' },
                { text: 'หลวงพระบาง' },
                { text: 'หัวพัน' },
                { text: 'อัตตะปือ' },
                { text: 'อุดมไซ' },
            ],
            maxCharacters: 50
        }
    },
    computed: {
        returnOptionCountry() {
            let tempValue = []
            this.countries.map((res) => {
                tempValue.push(res.text)
            })
            return tempValue
        },
        LanguageMessage() {
            return this.basefillupSetting.typeFillup === 'ENGLISH' ? 'ภาษาอังกฤษ' : 'ภาษาไทย'
        }
    },
    methods: {
        async onSubmitRecipient(data) {
            const country = await this.countries.find((res) => res.alpha_2_code === data.province)
            this.inputRecipient.name = data.name
            this.inputRecipient.address = data.address
            this.inputRecipient.address2 = data.address2
            this.inputRecipient.taxId = data.tax
            this.inputRecipient.state = data.state
            this.inputRecipient.city = data.district
            this.inputRecipient.country = {}
            this.inputRecipient.country.text = country.text
            this.inputRecipient.country.alpha_2_code = country.alpha_2_code
            this.inputRecipient.country.alpha_3_code = country.alpha_3_code
            this.inputRecipient.country.calling_code = country.calling_code
            this.inputRecipient.country.destination_supported = country.destination_supported
            this.inputRecipient.country.id = country.id
            this.inputRecipient.country.manufacturer_supported = country.manufacturer_supported
            this.inputRecipient.tel = data.tel
            this.inputRecipient.postcode = data.postcode
        },
        assignCityLAO(event) {
            this.inputRecipient.city = event.text
        },
        assigninputRecipient(event) {
            this.inputRecipient.country = {}
            this.inputRecipient.country.text = event.text
            this.inputRecipient.country.alpha_2_code = event.alpha_2_code
            this.inputRecipient.country.alpha_3_code = event.alpha_3_code
            this.inputRecipient.country.calling_code = event.calling_code
            this.inputRecipient.country.destination_supported = event.destination_supported
            this.inputRecipient.country.id = event.id
            this.inputRecipient.country.manufacturer_supported = event.manufacturer_supported
        },
        formatPhoneNumber() {
            const phoneNumberWithCallingCode = `${this.inputRecipient.tel}`;
            const parsedNumber = parsePhoneNumberFromString(phoneNumberWithCallingCode);
            if (parsedNumber) {
              this.inputRecipient.tel = parsedNumber.formatInternational();
            }

        },
        filterCountries() {
          const searchTerm = this.inputRecipient.selectedPhoneCountry.text.toLowerCase();
          this.filteredCountries = this.countries.filter(country =>
            country.calling_code.toLowerCase().startsWith(searchTerm) ||
            country.text.toLowerCase().startsWith(searchTerm)
          );
        },
        SetseletedCountry(event) {
            this.inputRecipient.selectedPhoneCountry.showInput = '+' + event.calling_code + ' '+ event.text
            this.inputRecipient.selectedPhoneCountry.text = event.text
            this.inputRecipient.selectedPhoneCountry.alpha_2_code = event.alpha_2_code
            this.inputRecipient.selectedPhoneCountry.alpha_3_code = event.alpha_3_code
            this.inputRecipient.selectedPhoneCountry.calling_code = event.calling_code
            this.inputRecipient.selectedPhoneCountry.destination_supported = event.destination_supported
            this.inputRecipient.selectedPhoneCountry.id = event.id
            this.inputRecipient.selectedPhoneCountry.manufacturer_supported = event.manufacturer_supported
        }
    },
    mounted() {
    }
}
</script>
